export default __webpack_public_path__ + "static/media/bed.95b48009.png";